import React, { Component } from "react"

import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"

import Icon from "react-icons-kit"
import { Menu } from "semantic-ui-react"
import "./ProMenu.css"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedProMenuItem extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {}

  render() {
    const { linkTo, name, onSelect, selected, icon } = this.props

    return (
      <Link to={linkTo} className={"proMenuItem"}>
        <Menu.Item as="span" name={name} active={selected} onClick={onSelect}>
          <Icon size={26} id="iconnavbar" icon={icon} />
          {name}
        </Menu.Item>
      </Link>
    )
  }
}

const ProMenuItemComponent = connect(mapStateToProps)(ConnectedProMenuItem)
export default translate("ProMenuComponent")(ProMenuItemComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/Header/ProMenuItem.jsx